export default {
  backendURL:  process.env.REACT_APP_BACKEND_URL || '',
  version:  'v1',
  apiPrefix: 'mobilede/api/mobile/passenger',
  isDevelopmentMode: process.env.NODE_ENV !== 'production',
}
